import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import SessionStorage from '../util/sessionstore'

const session = new SessionStorage()
const service = new ApolloClientService()

const { ROLE } = constants

export default class SignIn {
  login = (input) => {
    return new Promise((resolve, reject) => {
      service
        .login(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            let profile = this.format(data)
            session.setProfile(profile)
            resolve(profile)
          } else if (data.status == constants.MESSAGE.MAINTENANCE) {
            data.error = true
            data.message = data.message || constants.MESSAGE.MAINTENANCE_LOGIN_BANNER
            resolve(data)
          } else {
            data.error = true
            data.message = 'Wrong Credentials'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  loginWithOtp = (input) => {
    return new Promise((resolve, reject) => {
      service
        .loginWithOtp(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            if (data.trustToken)
              document.cookie = `trustToken=${data.trustToken}; Max-Age=${data.exp}; Path=/; Secure; SameSite=Strict`;
            let profile = this.format(data)
            session.setProfile(profile)
            resolve(profile)
          } else if (data.status == constants.MESSAGE.MAINTENANCE) {
            data.error = true
            data.message = data.message || constants.MESSAGE.MAINTENANCE_LOGIN_BANNER
            resolve(data)
          } else {
            data.error = true
            data.message = 'Invalid OTP'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  resendOtp = (input) => {
    return new Promise((resolve, reject) => {
      service
        .resendOtp(input)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            let profile = this.format(data)
            session.setProfile(profile)
            resolve(profile)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  resetPassword = (password, newpassword) => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      service
        .changeUserPassword({ password, newpassword, _id: profile.user._id })
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(profile)
          } else {
            data.error = true
            data.message = 'Wrong Credentials'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  deleteUserDeviceToken= () => {
    return new Promise((resolve, reject) => {
      let profile = session.getProfile()
      service
        .deleteUserDeviceToken(profile?.user._id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(profile)
          } else {
            data.error = true
            data.message = 'Wrong Credentials'
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }
  format = (data) => {
    return {
      token: data.token,
      customer: data.customer,
      company: data.company,
      trustToken:data.trustToken,
      exp:data.exp,
      message: 'OTP sent',
      user: {
        _id: data._id,
        firstname: data.firstname,
        lastname: data.lastname,
        email: data.email,
        userimage: data.userimage,
        role: data.role,
        signature: data.signature,
        surgeon: data.surgeon,
        lastlogintime: data.lastlogintime,
        patients_count: data.patients_count,
        filter: JSON.parse(data.filter),
      },
    }
  }

  changePassword = (params) => {
    return new Promise((resolve, reject) => {
      service
        .setPassword(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  // Resolves true when the set-password link still works, false when it has
  // expired (or was used). Rejects only on a network failure, so the page can
  // fall back to showing the form; the submit still enforces the same rule.
  checkPasswordLink = (token) => {
    return service
      .checkPasswordLink(token)
      .then((data) => !!data && data.status == constants.MESSAGE.SUCCESS)
  }

  resetPatientPassword = (params) => {
    return new Promise((resolve, reject) => {
      service
        .setPatientPassword(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  togglePatientStatus= (params) => {
    return new Promise((resolve, reject) => {
      service
        .togglePatientStatus(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  resetLoginFailedCount = (patientId) => {
    return new Promise((resolve, reject) => {
      service
        .resetLoginFailedCount(patientId)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  sendPatientAuthLink = (params) => {
    return new Promise((resolve, reject) => {
      service
        .sendPatientAuthLink(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  sendMobileAppLink = (params) => {
    return new Promise((resolve, reject) => {
      service
        .sendMobileAppLink(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  deleteAccountRequest = (params) => {
    return new Promise((resolve, reject) => {
      service
        .deleteAccountRequest(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  sendResetPasswordLink = (_id, email, captchaToken) => {
    return new Promise((resolve, reject) => {
      service
        .sendResetPasswordLink(_id, email, captchaToken)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  authorize_role = (roles, current_user) => {
    var role = current_user?.role?.toString()
    if (roles.includes(ROLE.ANONYMOUS)) return true
    else if (roles.includes(ROLE.AUTHORIZED))
      if (!Object.keys(current_user).length > 0) return false
      else return true
    else if (roles.includes(role)) return true
  }
  verifyActivityLinkOtp = (data) => {
    return new Promise((resolve, reject) => {
      service
        .verifyActivityLinkOtp(data)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  validPatientId = (data) => {
    return new Promise((resolve, reject) => {
      service
        .validPatientId(data)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            resolve(data)
          }
        })
        .catch((err) => reject(err))
    })
  }

  updateUserVisitedPages = (data) => {
    return new Promise((resolve, reject) => {
      service.updateUserVisitedPages(data)
      resolve(data).catch((err) => reject(err))
    })
  }

  getUserVisitedPages = (data) => {
    return new Promise((resolve, reject) => {
      service
        .getUserVisitedPages(data)
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  }
}
